import React from 'react';

import ArrowIcon from '~components/Icon/ArrowIcon';
import { MENU_TYPE } from '~features/home/constants';

import * as S from './style';

export interface Props {
  menuType: MENU_TYPE;
  onClick: (menuType: MENU_TYPE) => void;
  children: React.ReactNode;
  selected?: boolean;
}

function Menu({ menuType, children, selected, onClick }: Props) {
  return (
    <S.MenuWrapper onClick={() => onClick(menuType)} selected={selected}>
      <div id='outer'>
        <div id='inner'></div>
      </div>
      <div id='lower'>{children}</div>
      <ArrowIcon />
    </S.MenuWrapper>
  );
}

export default Menu;
